import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from "@emotion/styled";
import { getBackground } from "./blanketTheme";
export var opacity = function opacity(p) {
  return p.isTinted ? 1 : 0;
};
export var pointerEvents = function pointerEvents(p) {
  return p.canClickThrough ? "none" : "initial";
};
export var BlanketStyled = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background: ", "};\n    bottom: 0;\n    left: 0;\n    opacity: ", ";\n    pointer-events: ", ";\n    position: fixed;\n    right: 0;\n    top: 0;\n    transition: opacity 220ms;\n    z-index: ", ";\n"])), getBackground, opacity, pointerEvents, function (_ref) {
  var zIndex = _ref.zIndex;
  return zIndex;
});
//# sourceMappingURL=BlanketStyled.js.map